import { axiosInstance } from "../../config/axios";
import { logError } from '../../lib/rumLogger';
import { MESSAGE_SENT_EVENT, shouldOmitNotification } from "./enums";

export const getChannelArn = (channelId: string) => {
  return `arn:aws:chime:us-east-1:${process.env.REACT_APP_INSTANCE_BASE_ID}:app-instance/${process.env.REACT_APP_INSTANCE_ACCOUNT_ID}/channel/${channelId}`
}

export const sendChannelMessage = async (
  sender: any,
  channel: any,
  message: string,
  isPresence?: boolean,
  sourceApp?: string
) => {
  const params = {
    channelArn: channel?.channelArn,
    messagingUserId: sender?.userArn,
    messageContent: isPresence ? ' ' : message,
    persistence: isPresence ? 'NON_PERSISTENT' : 'PERSISTENT',
		type: isPresence ? 'CONTROL' : 'STANDARD',
  }

	let sentMessage = null
	await axiosInstance
		.post(`/channel/send-message`, JSON.stringify(params))
		.then(async (response) => {
			sentMessage = {
				response,
				CreatedTimeStamp: new Date(),
				Sender: {
					Arn: sender.externalUserId,
					Id: sender.messagingId,
				},
			};
			/* TODO: publish events */

			const messageId = response?.data?.MessageId ?? ''
			const omitNotification = shouldOmitNotification(sourceApp)
			const eventMetadata = {
				// omitNotifications: omitNotification,
				// sourceApp: sourceApp ?? ''
			}
			if(!isPresence) {
				await publishMessagingEvent({
					eventName: 'messageSent',
					messagingUserId: sender?.userArn,
					channelArn: channel?.channelArn,
					messageId: messageId,
					content: params.messageContent,
					// metadata: JSON.stringify(eventMetadata),
					metadata: undefined,
					isSelf: true,
					sourceApp: sourceApp ?? '',
					omitNotification: omitNotification
				})
			}

		})
		.catch((error) => {
			logError(error as Error, 'sendChannelMessage', {
				channelArn: channel?.channelArn,
				senderId: sender?.userArn });
		});
	return sentMessage;
}

type PublishMessagingEventParams = {
  eventName: string
  messagingUserId?: string
  channelArn?: string
  messageId?: string
  osVersion?: string
  applicantGuid?: string
  metadata?: string
  isSelf?: boolean
  content?: string
  omitNotification?: boolean
  sourceApp?: string
}

export const publishMessagingEvent = async (
  payload: PublishMessagingEventParams
) => {
  const params = {
    eventName: payload.eventName,
    app: "Web",
    eventDateTime: new Date().toISOString(),
    messagingUserId: payload.messagingUserId,
    channelArn: payload.channelArn,
    messageId: payload.messageId,
    osVersion: payload.osVersion ?? "",
    applicantGuid: payload.applicantGuid,
    metadata: payload.metadata,
    isSelf: payload.isSelf ?? false,
    content: payload.content ?? "",
    omitNotification: payload.omitNotification ?? false,
    sourceApp: payload.sourceApp ?? ""
  }

  try {
    await axiosInstance.post(`/publish/message/event`, params)
    return true
  } catch (err) {
    return err
  }
}